
    import '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/badge.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-weet-badge-demo-basic","docs-weet-badge-demo-maximum-number","docs-weet-badge-demo-standalone"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/badge.md?type=demo')
};